module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-wasou-costume-9e86ca778f06b30a702e9ae8d3e644a8.png";